import request from './request'

/**
 * 获取文章明细
 * 
 */
export function getArticleDel(data){
    let url = "/api/Article/GetArticleDetailAsync";
    return request({
        url: url,
        method: "get",
        dataType: "json",
        params:data
    });
}

/**
 * 获取文章点赞数  文件综合接口（点赞、收藏、下载、浏览）
 * 
 */
export function getThumbsDel(data){
    let url = "/api/FileComprehensive/CreateAsync";
    return request({
        url: url,
        method: "post",
        dataType: "json",
        data
    });
}

/**
 * 
 * 显示浏览
 */
export function createBrowse(data){
    let url = "/api/FileComprehensive/BrowseAsync";
    return request({
        url: url,
        method: "post",
        dataType: "json",
        data
    });
}

// 删除文件综合 
export function CancelLike(data){
    let url = "/api/FileComprehensive/DeleteAsync";
    return request({
        url: url,
        method: "post",
        dataType: "json",
        data
    });
}

/**
 * 下载文件
 * 
 */
export function downFileFirst(data){ //第一步
    let url = "/api/UpLoadFile/DownloadFileFirstAsync";
    return request({
        url: url,
        method: "get",
        dataType: "json",
        params:data
    });
}



// WEBPACK FOOTER //
// ./src/assets/js/modules/articleApi.js